import React, { useContext, useEffect, useState } from "react";
import TableSection from 'components/sales/tableSection/tableSection';
import localization from 'assets/localization/localization';
import { BaseUrl } from "../../../contexts/baseUrl/baseUrl";
import Layout from "../../../components/sales/layout/layout";
import Images from 'assets/images/imageData';
import { Link } from 'react-router-dom';

const RequestListing = ({
    history,
    match,
    requestApprovalList,
    approvalListDetails = [],
    documentUploadUrl,
}) => {

    const [isLoading, setIsLoading] = useState(false);
    const [pageCount, setPageCount] = useState(0);
    const { baseUrl } = useContext(BaseUrl);
    const [listData, setListData] = useState();
    const [isModal, setIsModal] = useState(false);
    const role = JSON.parse(localStorage.getItem('roles'));
    const [roleId, setRoleId] = useState('');

    useEffect(() => {
        (async () => {
            role && setRoleId(role[0].pivot.role_id);
        })();
    }, [role]);

    const handleModalHide = () => {
        setIsModal(false);
        window.location.reload();
    }

    useEffect(() => {
        (async () => {
            setIsLoading(true)
            await requestApprovalList(1, 4)
            setIsLoading(false)
        })()
    }, []);

    const successIconBox = (text, func) => {
        return (
            <div className="text-center">
                <div className="success">
                    <img src={Images?.tick} alt="" />
                </div>
                <h5>{text}</h5>
                <Link to="/dashboard/wallet/approval-listing" onClick={func} className="btn btn-transparent">
                    {localization.returnToList}{' '}
                    <img src={Images?.ArrowRight} alt="" />
                </Link>
            </div>
        );
    };

    const headers = [
        'Requested By',
        'Wallet Type',
        'Category',
        'Subcategory',
        'User Requested Amount',
        'Left Amount',
        'Finance Director',
        'Approved By',
        'Finance Date',
        'Status',
        'Created At',
        'Action'
    ];

    const onPageChange = async (val) => {
        setIsLoading(true);
        await requestApprovalList(val.selected + 1, 4);
        setIsLoading(false);
    };

    useEffect(() => {
        if (approvalListDetails &&
            approvalListDetails?.data !== undefined && approvalListDetails?.data.length > 0) {
            const tableData = ['id', 'created_by', 'wallet_type', 'category_name','subcategory', 'amount', 'left_redeem_amount', 'finance_approved_name', 'approved_name', 'finance_date', 'status', 'created_at'];
            const data = approvalListDetails?.data.map((element) => {
                const status = parseInt(element['status']);
                const isOld = parseInt(element['is_old']);
                const statusText = isOld === 0 ? 'Expired' :
                    status === 1 ? 'Manager Pending' :
                        status === 2 ? 'Finance Pending' :
                            status === 3 ? 'Manager Rejected' :
                                status === 4 ? 'Finance Approved' :
                                    status === 5 ? 'Finance Rejected' :
                                        'Unknown Status';

                const actionItems = [
                    { name: 'Transaction Details', link: `${baseUrl}/request-transaction-details` },
                    {name:'Request View', link:`${baseUrl}/wallet/approval-wallet-details`}
                ];

                if (isOld !== 0 && parseInt(element['left_redeem_amount']) > 0) {
                    actionItems.unshift({ name: 'Send to wallet', link: `${baseUrl}/wallet/new-request/${element.is_old}` });
                }

                return Object.assign(
                    ...tableData.map((key) => (
                        key === 'status' ? { [key]: statusText } : { [key]: element[key] }
                    )),
                    {
                        Action: actionItems
                    }
                );
            });

            if (data) {
                setListData(data);
            }
            setPageCount(Math.ceil(approvalListDetails.total / approvalListDetails.per_page));
        }
    }, [approvalListDetails]);

    return (
        <>
            <Layout
                title={localization.requestList}
                isLoading={isLoading}
                isGoback={true}
            >
                <TableSection
                    data={listData}
                    isId={false}
                    isMngId={false}
                    headers={headers}
                    pageCount={pageCount}
                    onPageChange={onPageChange}
                    detailList={approvalListDetails?.data && approvalListDetails?.data}
                    srNo={approvalListDetails?.from}
                />
            </Layout>
        </>
    )
}

export default RequestListing;
